import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { usePlayerContext } from "../../utils/PlayerContext";
import { PlayerStatus } from "../../utils/PlayerUtils";

const useExitConfirmation = ({
  confirmExit = false,
  validStatus,
  onConfirmed,
}: {
  confirmExit: boolean;
  validStatus: PlayerStatus[];
  onConfirmed: () => void;
}) => {
  const { t } = useTranslation();
  const { playerStatus } = usePlayerContext();
  const onBeforeUnload = useCallback(
    (e: BeforeUnloadEvent) => {
      if (confirmExit) {
        e.preventDefault();

        if (window.confirm(t("exitGame.confirmation"))) {
          onConfirmed();
        }

        return (e.returnValue = "Are you sure you want to exit?");
      } else {
        onConfirmed();
        return null;
      }
    },
    [onConfirmed],
  );

  useEffect(() => {
    if (validStatus.indexOf(playerStatus) !== -1) {
      window.addEventListener("beforeunload", onBeforeUnload);
      return () => {
        window.removeEventListener("beforeunload", onBeforeUnload);
      };
    }
  }, [onBeforeUnload, playerStatus]);

  return { onBeforeUnload };
};

export default useExitConfirmation;
